<div class="auth-page">
  <div class="auth-card">
    @if (!success) {
      <!-- Logo (mobile/tablet only) -->
      @if (screenType !== 'MONITOR') {
        <div class="auth-logo">
          <img src="/assets/logo-small.png" alt="Logo" />
        </div>
      }

      <div class="auth-header">
        <div class="auth-icon">
          <i class="pi pi-lock"></i>
        </div>
        <h2>Forgot your password?</h2>
        <p>Enter your email and we'll send you a reset link</p>
      </div>

      @if (error) {
        <p-message severity="error" text="Email does not exist."></p-message>
      }

      <form [formGroup]="forgotPasswordForm" (ngSubmit)="sendEmailForReset()">
        <div class="auth-field">
          <label for="email">Email address</label>
          <input pInputText id="email" formControlName="email" placeholder="you@company.com" />
          @if (
            forgotPasswordForm.controls['email'].invalid &&
            (forgotPasswordForm.controls['email'].touched ||
              forgotPasswordForm.controls['email'].dirty) &&
            forgotPasswordForm.controls['email'].errors
          ) {
            <small class="field-error">Please enter a valid email address.</small>
          }
        </div>

        <button
          type="submit"
          class="btn btn-primary auth-submit-btn"
          [disabled]="forgotPasswordForm.invalid || (isLoading$ | async) === true"
        >
          @if ((isLoading$ | async) === true) {
            <span class="spinner-border spinner-border-sm me-2"></span>
          }
          Send Reset Link
        </button>
      </form>

      <div class="auth-back">
        <a routerLink="/login" class="back-link">
          <i class="pi pi-arrow-left"></i> Back to login
        </a>
      </div>
    }

    @if (success) {
      <div class="success-state">
        <div class="success-icon">
          <i class="pi pi-check"></i>
        </div>
        <h2>Check your email</h2>
        <p>We've sent a password reset link to</p>
        <span class="success-email">{{ forgotPasswordForm.value['email'] }}</span>
        <a routerLink="/login" class="btn btn-light back-btn">Back to login</a>
      </div>
    }
  </div>
</div>
